import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { IWorkItem } from '../shared/workItem';
import { IProject } from '../shared/project';
import { IRepo } from '../shared/repo';
import { IBuild } from '../shared/build';
import { IWorkItemState } from '../shared/workItemState';
import { ICompareFormObj } from '../shared/compareFormObj';
import { IChange } from '../shared/change';
import { IBranch } from '../shared/branch';
import { IDbFormObj } from '../shared/IDbFormObj';

@Injectable()
export class CompareService {
  
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  constructor(private http: HttpClient) { }
  
  loadProjects(): Observable<IProject[]> {
    return this.http.get("/api/teamproject")
      .pipe(
        map((data: IProject[]) => {
          return data;
        }));
  }

  getReposByProject(project: string): Observable<IRepo[]> {
    return this.http.get("/api/projects/" + project + "/repos")
      .pipe(
        map((data: IRepo[]) => {
          return data;
        }));
  }

  getBuildsByRepo(project: string, repo: string, branchType: string): Observable<IBuild[]> {
    return this.http.get("/api/projects/" + project + "/repos/" + repo + "/builds?branchType=" + branchType)
      .pipe(
        map((data: IBuild[]) => {
          return data;
        }));
  }

  getWorkItemsByBuild(project: string, buildId: number): Observable<IWorkItem[]> {
    return this.http.get("/api/projects/" + project + "/builds/" + buildId + "/workitem")
      .pipe(
        map((data: IWorkItem[]) => {
          return data;
        }));
  }

  getWorkItemsBetweenBuilds(project: string, buildFrom: number, buildTo: number): Observable<IWorkItem[]> {
    return this.http.get("/api/projects/" + project + "/workitems?buildFrom=" + buildFrom + "&buildTo=" + buildTo)
      .pipe(
        map((data: IWorkItem[]) => {
          return data;
        }));
  }

  getWorkItemsBetweenBuildsBatch(compareObj: ICompareFormObj[]): Observable<IWorkItem[]> {
    return this.http.post("/api/workitems/batch", compareObj, this.httpOptions)
      .pipe(
        map((data: IWorkItem[]) => {
          return data;
        }),
        catchError(this.handleError<any>("getWorkItemsBetweenBuildsBatch", compareObj))
      );
  }

  updateWorkItemState(workitem: number, state: string) {
    return this.http.put("/api/workitem/" + workitem + "/states/" + state, "");
  }

  getWorkItemStates(project: string): Observable<IWorkItemState[]> {
    return this.http.get("/api/projects/" + project + "/states")
      .pipe(
        map((data: IWorkItemState[]) => {
          return data;
        }));
  }

  getChangesBetweenBuildsByRepo(project: string, repo: string, branchFrom: string, branchTo: string): Observable<IChange[]> {
    return this.http.get("/api/projects/" + project + "/repos/" + repo + "/changes?branchFrom=" + branchFrom + "&branchTo=" + branchTo)
      .pipe(
        map((data: IChange[]) => {
          return data;
        }));
  }

  getChangesBetweenBuildsByRepoBatch(dbObj: IDbFormObj[]): Observable<IChange[]> {
    return this.http.post("/api/changes/batch", dbObj, this.httpOptions)
      .pipe(
        map((data: IChange[]) => {
          return data;
        }),
        catchError(this.handleError<any>("getChangesBetweenBuildsByRepoBatch", dbObj))
      );
  }

  getBranchesByRepo(project: string, repo: string) {
    return this.http.get("/api/projects/" + project + "/repos/" + repo + "/branches")
      .pipe(
        map((data: IBranch[]) => {
          return data;
        }));
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      return of(result as T);
    }
  }
}
